import { StoreMarkerOutlineIcon } from './StoreMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id EA9439C2-511C-4A27-BABD-D0C1F8E824A0
 * name store-marker-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-marker-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Navigation 
 */
export const ShopLocationOutlineIcon = StoreMarkerOutlineIcon;
export default ShopLocationOutlineIcon